module.exports = __webpack_public_path__ + "img/bg.21493536.png";